module.exports = __webpack_public_path__ + "static/media/jacket-2.b527faeb.jpg";